import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import * as Sentry from "@sentry/react";

const isSentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true'
const sentryDsn = import.meta.env.VITE_SENTRY_DSN

// localhost 체크
const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'

if (isSentryEnabled && sentryDsn && !isLocalhost) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    // 에러 샘플링 비율 (모든 에러 추적)
    sampleRate: 1.0,
    // 통합 기능
    integrations: [
      // 페이지 로딩, 네비게이션 성능 추적
      Sentry.browserTracingIntegration(),

      // 세션 리플레이 (에러 발생 시 사용자 행동 녹화)
      Sentry.replayIntegration({
        maskAllText: true, // 텍스트 마스킹 (개인정보 보호)
        blockAllMedia: true, // 이미지/비디오 차단
      }),
    ],

    // 세션 리플레이 샘플링
    replaysSessionSampleRate: 0.1, // 정상 세션의 10%만 녹화
    replaysOnErrorSampleRate: 1.0, // 에러 발생 시 100% 녹화

    // 무시할 에러 패턴
    ignoreErrors: [
      // 브라우저 자체 에러
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',

      // Promise rejection
      'Non-Error promise rejection captured',

      // 취소된 요청
      'Request aborted',
      'canceled',
    ],

    // 에러 전송 전 처리
    beforeSend(event) {
      // 민감한 정보 제거
      if (event.request) {
        // 쿠키 제거
        delete event.request.cookies

        // Authorization 헤더 제거
        if (event.request.headers) {
          delete event.request.headers['Authorization']
          delete event.request.headers['authorization']
        }

        // URL에서 토큰 제거
        if (event.request.url) {
          event.request.url = event.request.url.replace(
            /([?&]token=)[^&]+/g,
            '$1***'
          )
        }
      }

      // Extra 데이터에서 민감 정보 제거
      if (event.extra) {
        delete event.extra.password
        delete event.extra.token
        delete event.extra.apiKey
      }

      return event
    },

    // Breadcrumb 필터링 (사용자 행동 추적 로그)
    beforeBreadcrumb(breadcrumb) {
      // 콘솔 로그 제외
      if (breadcrumb.category === 'console') {
        return null
      }

      // XHR/Fetch에서 민감 정보 제거
      if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
        if (breadcrumb.data?.url) {
          breadcrumb.data.url = breadcrumb.data.url.replace(
            /([?&]token=)[^&]+/g,
            '$1***'
          )
        }
      }

      return breadcrumb
    },
  })
  console.log(`✅ Sentry initialized - Environment: ${import.meta.env.VITE_SENTRY_ENVIRONMENT}`)
} else {
  if (isLocalhost) {
    console.log('ℹ️ Sentry is disabled (localhost)')
  } else {
    console.log('ℹ️ Sentry is disabled')
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <App />
  </StrictMode>,
)
